/* eslint-disable import/prefer-default-export */
import queryString from 'query-string';
import { generatePath } from 'react-router-dom';

import { API_RECEIPT_PRODUCT_CATEGORIES_URL, API_RECEIPT_PRODUCT_LIST_URL } from '../../constants/apiUrls';
import { getRequestJSON } from '../../util/services';

interface QueryParams {
  page?: number;
  perPage?: number;
}
export const getProductList = (apiHost: string, keyword: string, { page, perPage }: QueryParams): Promise<any> =>
  getRequestJSON(
    apiHost,
    generatePath(API_RECEIPT_PRODUCT_LIST_URL, {
      '*': `?${queryString.stringify({
        name_input: keyword,
        page: page + 1,
        per_page: perPage,
      })}`,
    })
  );

export const getProductCategories = (apiHost: string, keyword: string, { page, perPage }: QueryParams): Promise<any> =>
  getRequestJSON(
    apiHost,
    generatePath(API_RECEIPT_PRODUCT_CATEGORIES_URL, {
      '*': `?${queryString.stringify({
        name_input: keyword,
        page: page + 1,
        per_page: perPage,
      })}`,
    })
  );
